import {BaseCollection} from '../BaseCollection';
import {AggregatedUserNotificationModel} from '../../model/notifications/AggregatedUserNotificationModel';
import {BaseModel} from '../../model/base/BaseModel';
import {BaseFilterModel} from '../../model/filter/BaseFilterModel';

/**
 * @class AggregatedUserNotificationCollection
 * @extends BaseCollection
 */
export class AggregatedUserNotificationCollection extends BaseCollection {

    get model () {
        return AggregatedUserNotificationModel;
    }

    initialize (models, options) {
        super.initialize(models, options);
        this.microservice = 'notifications';
        this.resource = 'aggregated-user-notifications';
    }

    static factory ({userId, language, country}) {
        const today = BaseModel.getLocalMoment().startOf('day');
        const SECONDS_IN_DAY = 60 * 60 * 24;
        const filterParams = {
            fromDate: BaseModel.serializeDate(today.clone().subtract(20 * SECONDS_IN_DAY, 's')), // subtracting seconds to avoid problems with daylight switches
            endDate: BaseModel.serializeDate(today.clone().endOf('day')),
            aggregationDuration: SECONDS_IN_DAY,
            type: _.values(AggregatedUserNotificationModel.TYPES).join(','),
            userId, language, country,
        };

        return new AggregatedUserNotificationCollection([], {
            filterParams : new BaseFilterModel(filterParams),
        });
    }

}


// WEBPACK FOOTER //
// ./shared/collection/notifications/AggregatedUserNotificationCollection.js